import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import "./style.scss";
import { LoginActions } from "@Pages";
import { AuthActions } from "@Store";
import { useTranslation } from "react-i18next";

type FormData = {
    username: string;
    password: string;
};

export const LoginForm = () => {
    const { t } = useTranslation();
    const { register, handleSubmit, reset } = useForm<FormData>();
    const dispatch = useDispatch<any>();

    const onSubmit = async ({ username, password }: FormData) => {
        username = username.trim().toLowerCase();
        try {
            dispatch(
                LoginActions.PostLoginAccount({
                    username,
                    password,
                })
            );
        } catch (error) {
            setTimeout(() => {
                reset();
                dispatch(AuthActions.authFailure());
            }, 2000);
        }
    };

    const handleShowErrorMsg = (e: any) => {
        // setErrorMessage(false);
    };

    return (
        <form
            className="LoginForm"
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
        >
            <ul className="LoginForm-ul m-0">
                <li>
                    <input
                        type="text"
                        className="LoginForm__input"
                        placeholder={t("login.username")}
                        onFocus={handleShowErrorMsg}
                        {...register("username", { required: true })}
                    />
                </li>
                <li>
                    <input
                        type="password"
                        className="LoginForm__input"
                        placeholder={t("login.password")}
                        autoComplete="current-password"
                        onFocus={handleShowErrorMsg}
                        {...register("password", { required: true })}
                    />
                </li>
                <li>
                    <button
                        type="submit"
                        className="ButtonLogin ButtonLogin-gray"
                    >
                        {t("login.login_desc")}
                    </button>
                </li>
            </ul>
        </form>
    );
};

export default LoginForm;
